import StoredLayout from '../../layouts/StoredLayout'
import LineChartWidgets from './LineChartWidgets'
export default StoredLayout(LineChartWidgets)
